import { render } from "./CustomDomainSettings.vue?vue&type=template&id=64d239e3"
import script from "./CustomDomainSettings.vue?vue&type=script&lang=js"
export * from "./CustomDomainSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__